module.exports = __webpack_public_path__ + "static/media/vend-logo.40a3357e.svg";